import React from 'react';
import { Paper, Stack, FormControlLabel, Switch, TextField, Typography } from '@mui/material';

const SoftDeleteSection = ({ formValues, labelColor, switchSx, onToggle, onDateChange }) => (
  <Paper
    elevation={0}
    sx={{
      bgcolor: 'var(--wb-x-bg-141b2d, #141b2d)',
      border: '1px solid var(--wb-x-border-3b82f659, rgba(59, 130, 246, 0.35))',
      borderRadius: 0,
      p: 3
    }}
  >
    <Typography variant="subtitle1" sx={{ color: 'var(--wb-accent)', fontWeight: 600, mb: 2 }}>
      Borrado lógico
    </Typography>
    <Stack direction="row" spacing={2} alignItems="center" flexWrap="wrap">
      <FormControlLabel
        control={
          <Switch
            checked={formValues.softDelete.deleted}
            onChange={onToggle}
            sx={switchSx}
          />
        }
        label={formValues.softDelete.deleted ? 'Entidad marcada como eliminada' : 'Entidad activa'}
        sx={{ color: 'var(--wb-text-strong)' }}
      />
      {formValues.softDelete.deleted && (
        <TextField
          label="Fecha de eliminación"
          placeholder="2024-01-31T12:00:00Z"
          value={formValues.softDelete.deleted_at}
          onChange={onDateChange}
          size="small"
          InputLabelProps={{ sx: labelColor }}
          InputProps={{ sx: { color: 'var(--wb-text)', '& .MuiOutlinedInput-notchedOutline': { borderColor: 'var(--wb-blue-strong)' }, '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'var(--wb-blue)' }, '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: 'var(--wb-blue-light)' }, '& .MuiOutlinedInput-input': { py: '6px', px: '12px' } } }}
        />
      )}
    </Stack>
  </Paper>
);

export default SoftDeleteSection;
